import type { ComboboxOption } from '@multaqa/ui/components/ui/combobox'

/** Where a listed item stands in the line's warehouse; only `in_stock` can be picked. */
export type CatalogStockGroup = 'in_stock' | 'out_of_stock' | 'not_here'

export type CatalogStockState = {
  group: CatalogStockGroup
  /** What the warehouse has available, for an item it stocks. */
  available?: string
}

const ORDER: CatalogStockGroup[] = ['in_stock', 'out_of_stock', 'not_here']

/**
 * The picker's options under one heading per stock group, in stock first.
 * Every item stays listed so the user sees the whole catalogue; an item out
 * of stock, or not in the warehouse at all, is shown but cannot be picked.
 * The chosen item stays pickable wherever it falls, so the field keeps it.
 */
export function groupOptionsByStock(
  options: { option: ComboboxOption; state: CatalogStockState }[],
  value: string,
  heading: (group: CatalogStockGroup) => string,
): ComboboxOption[] {
  return ORDER.flatMap((group) => {
    const members = options.filter((entry) => entry.state.group === group)
    if (members.length === 0) return []
    return [
      { value: `__stock-group-${group}`, label: heading(group), disabled: true },
      ...members.map(({ option }) =>
        group === 'in_stock' || option.value === value ? option : { ...option, disabled: true },
      ),
    ]
  })
}
